module.exports = __webpack_public_path__ + "img/3.60991c84.png";